module.exports = __webpack_public_path__ + "img/magic.c8d0dd31.svg";